import { ReactNode, useState, useEffect } from "react";
import classes from "./viewport.module.css";

type Size = {
  className: string;
  mediaQuery: string;
};

export const useMatchMedia = (is: Size): boolean | null => {
  const [match, setMatch] = useState<
    MediaQueryList | MediaQueryListEvent | null
  >(null);
  useEffect(() => {
    if (!window) {
      return;
    }
    const matcher = window.matchMedia(is.mediaQuery);
    matcher.addEventListener("change", setMatch);
    setMatch(matcher);

    return () => {
      matcher.removeEventListener("change", setMatch);
    };
  }, [is]);
  if (match === null) return null;

  return match?.matches && match?.media === is.mediaQuery;
};

export type ViewportProps = {
  children: ReactNode;
  is: Size;
};

export const Viewport = ({ children, is }: ViewportProps) => {
  const match = useMatchMedia(is);
  const tempProps: { className?: string } = {
    className: classes.wrapper,
  };

  if (match === false) {
    return null;
  }

  if (match === null) {
    tempProps.className = `${tempProps.className} ${is.className}`;
  }

  return <div {...tempProps}>{children}</div>;
};
